
















































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { SysConst as SC } from '@/trials/plugins/const';
import { sessionModule } from '@/trials/store/modules/session';
import DragDrop from '@/trials/views/components/DragDrop.vue';

import ConfirmDialogData from '@/trials/domain/objects/confirmDialogData';

@Component({ components: { DragDrop } })
export default class PredictData extends Vue {
    /*----------------------------------*
     * Data
     *-----------------------------------*/
    private nextBtnColorBg: string = SC.Color.Button.Next.BG;
    private clearBtnColorBg: string = SC.Color.Button.Clear.BG;
    /*----------------------------------*
     * Computed
     *-----------------------------------*/
    // アクティブコンテンツ
    private get currentContent() {
        return sessionModule.getCurrentRouterViewPredictData;
    }

    /* Active, Disabledフラグ
        --------------------------*/
    // アップロード
    private get activeUpload(): boolean {
        return this.$route.path.startsWith(SC.Path.PREDICT_DATA_UPLOAD);
    }
    private get disabledUpload(): boolean {
        return this.activeUpload;
    }

    // 統計情報
    private get activeStatistics() {
        return this.$route.path.startsWith(SC.Path.PREDICT_DATA_STATISTICS);
    }
    private get disabledStatistics() {
        return this.activeStatistics || !this.isAggregated;
    }

    // 推論 可能フラグ(0件以上の推論データの投入を確認する)
    private get isPredictable(): boolean {
        return sessionModule.getPredictData !== null;
    }

    // 統計情報の集計済 フラグ
    private get isAggregated(): boolean {
        return sessionModule.getPredictDataStatistics.length > 0;
    }

    // 予測したかどうか
    private get isPredicted(): boolean {
        return sessionModule.getPredicted === SC.Flag.Process.DONE;
    }

    // 予測中フラグ
    private get isPredicting(): boolean {
        return sessionModule.getPredicted === SC.Flag.Process.DOING;
    }

    /*----------------------------------*
     * ライフサイクルフック
     *-----------------------------------*/
    mounted() {
        // Child コンポーネントの指定なし
        if (this.$route.path == SC.Path.PREDICT_DATA_MENU) {
            // 有効データ未投入の場合、アップロード画面に遷移
            if (!this.isPredictable) {
                sessionModule.SET_ROUTE_PREDICT_DATA(SC.Path.PREDICT_DATA_UPLOAD);
            }
            this.$router.replace(this.currentContent);
        }
    }

    /*----------------------------------*
     * Methods
     *-----------------------------------*/
    // コンテンツ表示
    private viewContent(content: string) {
        sessionModule.SET_ROUTE_PREDICT_DATA(content);
        this.$router.push(this.currentContent);
    }

    /* Clickメソッド(コンテンツ切替)
        -------------------------------*/
    // データアップロード
    private toUpload() {
        this.viewContent(SC.Path.PREDICT_DATA_UPLOAD);
    }

    // 統計情報
    private toStatistics() {
        this.viewContent(SC.Path.PREDICT_DATA_STATISTICS);
    }

    // 推論
    private prediction() {
        const self = this;
        const confirm = new ConfirmDialogData(
            'trials.dialog.contents.start.predict.title',
            'trials.dialog.contents.start.predict.message',
            function() {
                // 推論結果へ遷移
                self.$router.push(SC.Path.PREDICT_DATA_PREDICTING);
            }
        );
        sessionModule.showConfirmDialog(confirm);
    }

    // 予測の初期化
    private format() {
        const self = this;
        const confirm = new ConfirmDialogData(
            'trials.dialog.contents.format.predict.title',
            'trials.dialog.contents.format.predict.message',
            function() {
                sessionModule.formatPredict();
                // アップロード画面以外で実行された場合、アップロード画面に戻る
                if (self.$route.path != SC.Path.PREDICT_DATA_UPLOAD) {
                    self.$router.replace(SC.Path.PREDICT_DATA_UPLOAD);
                }
            }
        );
        sessionModule.showConfirmDialog(confirm);
    }
}
